export enum MetadataType {
  AUTOMATION_TEST_INPUT = "automationTestInput",
  AUTOMATION_TEST_HISTORY = "automationTestHistory",
}
